import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Anvandarvillkor() {
  useEffect(() => {
    document.title = "Användarvillkor – vidalv.live";
    window.scrollTo(0, 0);
  }, []);

  return (
    <article data-testid="legal-anvandarvillkor" className="max-w-3xl mx-auto px-4 sm:px-6 py-10 sm:py-14">
      <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-pine hover:text-pine-hover no-underline mb-6">
        <ArrowLeft size={14} /> Tillbaka till startsidan
      </Link>
      <h1 className="font-fraktur-smooth text-falu text-3xl sm:text-4xl mb-2">Användarvillkor</h1>
      <p className="text-xs text-bark/60 mb-8">Gäller från: 24 april 2026</p>

      <section className="space-y-4 text-ink leading-relaxed">
        <h2 className="font-heading text-xl font-semibold text-ink mt-2 mb-2">1. Om tjänsten</h2>
        <p>
          vidalv.live (&bdquo;tjänsten&rdquo;) är en icke-kommersiell, lokal samlingsplats för Backe, Rossön och bygderna vid
          Fjällsjöälven. Tjänsten tillhandahålls av <strong>Hodema Edertools AB</strong>
          (org. nr. 556887-7699, Kyrkvägen 66, 883 72 Backe) via redaktionen på <a href="mailto:redaktion@vidalv.live" className="text-falu">redaktion@vidalv.live</a>.
        </p>

        <h2 className="font-heading text-xl font-semibold text-ink mt-6 mb-2">2. Accepterande av villkoren</h2>
        <p>
          Genom att använda tjänsten, skicka in innehåll eller logga in som moderator godkänner du dessa
          villkor. Samtycker du inte – använd inte tjänsten.
        </p>

        <h2 className="font-heading text-xl font-semibold text-ink mt-6 mb-2">3. Användargenererat innehåll</h2>
        <p>Du garanterar att allt material du skickar in:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>är skapat av dig eller att du har rätt att använda det,</li>
          <li>inte kränker tredje parts upphovsrätt, varumärkes- eller personliga rättigheter,</li>
          <li>inte innehåller hot, trakasserier, hets mot folkgrupp, pornografi, eller olagligt innehåll,</li>
          <li>är korrekt och inte vilseledande,</li>
          <li>inte är politisk eller religiös agitation.</li>
        </ul>
        <p>
          Redaktionen granskar allt innehåll innan publicering och förbehåller sig rätten att avvisa,
          redigera eller ta bort bidrag utan motivering.
        </p>

        <h2 className="font-heading text-xl font-semibold text-ink mt-6 mb-2">4. Licens till ditt innehåll</h2>
        <p>
          När du skickar in bilder, texter, video eller ljud ger du vidalv.live en <strong>icke-exklusiv,
          vederlagsfri, återkallbar licens</strong> att visa materialet på tjänsten och i dess tekniska
          funktioner (t.ex. översättningscache, miniatyrer, RSS-flöden). Du behåller upphovsrätten.
          Du kan när som helst begära att ditt bidrag tas bort via <a href="mailto:redaktion@vidalv.live" className="text-falu">redaktion@vidalv.live</a>.
        </p>

        <h2 className="font-heading text-xl font-semibold text-ink mt-6 mb-2">5. Köp &amp; sälj lokalt</h2>
        <p>
          Annonser under &bdquo;Köp &amp; sälj lokalt&rdquo; är ett erbjudande mellan privatpersoner i bygden.
          vidalv.live är <strong>inte part</strong> i avtalet och tar inget ansvar för transaktioner,
          kvalitet eller tvister. Var uppmärksam och möt säljare på säker plats.
        </p>

        <h2 className="font-heading text-xl font-semibold text-ink mt-6 mb-2">6. Moderatorernas roll</h2>
        <p>
          Moderatorer är frivilliga lokala personer som redaktionen utsett. Deras insatser är frivilliga
          och representerar inte Hodema Edertools AB:s officiella ståndpunkt. Master-kontot är redaktionens huvudkonto.
        </p>

        <h2 className="font-heading text-xl font-semibold text-ink mt-6 mb-2">7. Ansvarsbegränsning</h2>
        <p>
          Tjänsten tillhandahålls i befintligt skick. Vi strävar efter korrekthet men garanterar inte
          ständig tillgänglighet, felfrihet eller att innehållet är uppdaterat. Hodema Edertools AB
          ansvarar <strong>inte</strong> för:
        </p>
        <ul className="list-disc pl-6 space-y-1">
          <li>skador orsakade av information inlämnad av tredje part,</li>
          <li>transaktioner mellan användare (t.ex. uthyrning, försäljning, tjänsteutbyten),</li>
          <li>externa länkar,</li>
          <li>avbrott eller dataförluster.</li>
        </ul>
        <p>Ansvarsbegränsningen gäller i den utsträckning svensk lag tillåter.</p>

        <h2 className="font-heading text-xl font-semibold text-ink mt-6 mb-2">8. Immaterialrätt &amp; varumärke</h2>
        <p>
          Varumärket &bdquo;vidalv.live&rdquo;, designen (Folkhem/Jugendstil-stilen), den redaktionella
          strukturen, Ångermanlands-vapnet-användningen samt den tekniska plattformen tillhör Hodema Edertools AB.
          Bygdens heraldik (tre silverlaxar, Ångermanlands vapen) är allmän egendom.
        </p>

        <h2 className="font-heading text-xl font-semibold text-ink mt-6 mb-2">9. Avstängning</h2>
        <p>
          Vi kan stänga av användare eller ta bort innehåll som bryter mot dessa villkor, utan
          förvarning, enligt eget omdöme.
        </p>

        <h2 className="font-heading text-xl font-semibold text-ink mt-6 mb-2">10. Tillämplig lag &amp; tvister</h2>
        <p>
          Svensk lag gäller. Tvister avgörs i första hand av <strong>Ångermanlands tingsrätt</strong>.
          Konsumenter kan även vända sig till <a href="https://www.arn.se" target="_blank" rel="noopener noreferrer" className="text-falu">Allmänna reklamationsnämnden (ARN)</a>.
        </p>

        <h2 className="font-heading text-xl font-semibold text-ink mt-6 mb-2">11. Kontakt</h2>
        <p>
          <a href="mailto:redaktion@vidalv.live" className="text-falu">redaktion@vidalv.live</a><br />
          Hodema Edertools AB, Kyrkvägen 66, 883 72 Backe
        </p>
      </section>
    </article>
  );
}
